import React from 'react'
import { useDraggable } from '@dnd-kit/core'

export const dashedBorderCss = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23333' stroke-width='3' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`
export const dashedBorderCssStyle = {
  backgroundImage: dashedBorderCss,
}

function Draggable({
  id,
  children,
  style,
  dragHandle,
  childrenStyle,
  dragHandleStyle = {},
  disabled = false,
  data,
  testId,
}) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    disabled,
    data,
  })
  const bodyListeners = dragHandle ? {} : listeners

  return (
    <div ref={setNodeRef} style={style} {...bodyListeners} {...attributes} data-testid={testId}>
      <div style={childrenStyle}>{children}</div>
      {dragHandle && (
        <div {...listeners} style={dragHandleStyle}>
          {dragHandle}
        </div>
      )}
    </div>
  )
}

export default Draggable
